import React from 'react';
export const Wisdom = React.createContext()